import React from 'react';
import debounce from 'packages/debounce';

const DebouncedProps = (Component, wait) => class DebouncedContainer extends Component {
    constructor(props) {
        super(props);
        this.state = props;
        this.updateState = debounce(this.updateState, wait);
    }

    componentWillReceiveProps(props) {
        this.updateState(props);
    }

    updateState() {
        this.setState(this.props);
    }

    render() {
        return <Component {...this.state} />;
    }

};

export default DebouncedProps;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/debounce-props/debounce-props.jsx